module.exports = __webpack_public_path__ + "img/DXTrade-tab-icon.69a84e07.png";